// Open dropdowns and inline edits register here while open. A click outside the topmost
// one (or Esc) only closes it: the rest of that click (mousedown, focus, click) is
// swallowed, so it neither triggers what was under the pointer nor closes the modal.
import m from './m.js'

const stack = []
let swallowClick = false

/**
 * entry: { contains(target), close(), escape?() }; escape defaults to close.
 * Returns a function that unregisters the entry.
 */
export function onDismiss(entry) {
  stack.push(entry)
  return () => {
    const i = stack.indexOf(entry)
    if (i >= 0) stack.splice(i, 1)
  }
}

document.addEventListener(
  'pointerdown',
  evt => {
    swallowClick = false
    const entry = stack.at(-1)
    if (!entry || entry.contains(evt.target)) return
    // preventDefault on pointerdown also suppresses mousedown/mouseup and the focus change
    evt.preventDefault()
    evt.stopPropagation()
    swallowClick = true
    entry.close()
    m.redraw()
  },
  true
)

document.addEventListener(
  'click',
  evt => {
    if (!swallowClick) return
    swallowClick = false
    evt.preventDefault()
    evt.stopPropagation()
  },
  true
)

document.addEventListener(
  'keydown',
  evt => {
    const entry = stack.at(-1)
    if (evt.key !== 'Escape' || !entry) return
    evt.preventDefault()
    evt.stopImmediatePropagation()
    ;(entry.escape || entry.close)()
    m.redraw()
  },
  true
)
